// Location single, custom post type, slider

jQuery(document).ready(function($) {
  let $images = $(".location-image-item");
  $images.first().addClass("active-image");
  $images.last().addClass("prev");
  $images
    .first()
    .next()
    .addClass("next");

  let $pagDots = $(".image-pagination .pagination-dot");
  $pagDots.first().addClass("active-dot");

  // handle LR arrow clicks
  $(".arrow-wrapper").click(function(e) {
    e.preventDefault();
    let $active = $(".location-image-item.active-image");
    $images.removeClass("active-image");
    $images.removeClass("next");
    $images.removeClass("prev");
    $pagDots.removeClass("active-dot");

    if ($(this).hasClass("arrow-right")) {
      $active = $images.eq(($active.index() - 1) % $images.length);
    } else {
      $active = $images.eq(($active.index() + 1) % $images.length);
    }
    $active.addClass("active-image");
    $images.eq(($active.index() - 1) % $images.length).addClass("prev");
    $images.eq(($active.index() + 1) % $images.length).addClass("next");
    $pagDots.eq($active.index()).addClass("active-dot");
  });

  // handle pagination dot clicks
  $pagDots.click(function(e) {
    $images.removeClass("active-image");
    $images.removeClass("next");
    $images.removeClass("prev");
    $pagDots.removeClass("active-dot");

    $(this).addClass("active-dot");
    let i = $(this).index();
    $images.eq(i).addClass("active-image");
    $images.eq((i - 1) % $images.length).addClass("prev");
    $images.eq((i + 1) % $images.length).addClass("next");
  });
});
